import { default as iframedVk1hEcH3XMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/chirashi/iframe.vue?macro=true";
import { default as index6Npum7woLSMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/chirashi/index.vue?macro=true";
import { default as viewerg5arIgsfbCMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/chirashi/viewer.vue?macro=true";
import { default as _91id_93Ejf2YDFFV0Meta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/content/[id].vue?macro=true";
import { default as indexx7DEdKuFOuMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/content/survey/index.vue?macro=true";
import { default as index6piFtCYDP6Meta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/faq/index.vue?macro=true";
import { default as indexPlzVMlBYqDMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/index.vue?macro=true";
import { default as indexuEiL42Nv80Meta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/maker-theme/index.vue?macro=true";
import { default as indexjl4JC2qxKRMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/maker-theme/survey/index.vue?macro=true";
import { default as indexnxarsyo3GHMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/my-store/index.vue?macro=true";
import { default as _91type_93wCpmHlD0hJMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/my-store/search/[type].vue?macro=true";
import { default as indexiqze3trjr1Meta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/my-store/search/index.vue?macro=true";
import { default as index9gsVWZ1suHMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/preview/chirashi/index.vue?macro=true";
import { default as viewerWcrDU63FXnMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/preview/chirashi/viewer.vue?macro=true";
import { default as indexglwi6ri8MRMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/privacy-policy/index.vue?macro=true";
import { default as indexhKRSCStKuFMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/product/index.vue?macro=true";
import { default as indexF2uTCHU2aDMeta } from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/theme/index.vue?macro=true";
export default [
  {
    name: iframedVk1hEcH3XMeta?.name ?? "chirashi-iframe",
    path: iframedVk1hEcH3XMeta?.path ?? "/chirashi/iframe",
    meta: iframedVk1hEcH3XMeta || {},
    alias: iframedVk1hEcH3XMeta?.alias || [],
    redirect: iframedVk1hEcH3XMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/chirashi/iframe.vue").then(m => m.default || m)
  },
  {
    name: index6Npum7woLSMeta?.name ?? "chirashi",
    path: index6Npum7woLSMeta?.path ?? "/chirashi",
    meta: index6Npum7woLSMeta || {},
    alias: index6Npum7woLSMeta?.alias || [],
    redirect: index6Npum7woLSMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewerg5arIgsfbCMeta?.name ?? "chirashi-viewer",
    path: viewerg5arIgsfbCMeta?.path ?? "/chirashi/viewer",
    meta: viewerg5arIgsfbCMeta || {},
    alias: viewerg5arIgsfbCMeta?.alias || [],
    redirect: viewerg5arIgsfbCMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Ejf2YDFFV0Meta?.name ?? "content-id",
    path: _91id_93Ejf2YDFFV0Meta?.path ?? "/content/:id()",
    meta: _91id_93Ejf2YDFFV0Meta || {},
    alias: _91id_93Ejf2YDFFV0Meta?.alias || [],
    redirect: _91id_93Ejf2YDFFV0Meta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/content/[id].vue").then(m => m.default || m)
  },
  {
    name: indexx7DEdKuFOuMeta?.name ?? "content-survey",
    path: indexx7DEdKuFOuMeta?.path ?? "/content/survey",
    meta: indexx7DEdKuFOuMeta || {},
    alias: indexx7DEdKuFOuMeta?.alias || [],
    redirect: indexx7DEdKuFOuMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/content/survey/index.vue").then(m => m.default || m)
  },
  {
    name: index6piFtCYDP6Meta?.name ?? "faq",
    path: index6piFtCYDP6Meta?.path ?? "/faq",
    meta: index6piFtCYDP6Meta || {},
    alias: index6piFtCYDP6Meta?.alias || [],
    redirect: index6piFtCYDP6Meta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/faq/index.vue").then(m => m.default || m)
  },
  {
    name: indexPlzVMlBYqDMeta?.name ?? "index",
    path: indexPlzVMlBYqDMeta?.path ?? "/",
    meta: indexPlzVMlBYqDMeta || {},
    alias: indexPlzVMlBYqDMeta?.alias || [],
    redirect: indexPlzVMlBYqDMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexuEiL42Nv80Meta?.name ?? "maker-theme",
    path: indexuEiL42Nv80Meta?.path ?? "/maker-theme",
    meta: indexuEiL42Nv80Meta || {},
    alias: indexuEiL42Nv80Meta?.alias || [],
    redirect: indexuEiL42Nv80Meta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/maker-theme/index.vue").then(m => m.default || m)
  },
  {
    name: indexjl4JC2qxKRMeta?.name ?? "maker-theme-survey",
    path: indexjl4JC2qxKRMeta?.path ?? "/maker-theme/survey",
    meta: indexjl4JC2qxKRMeta || {},
    alias: indexjl4JC2qxKRMeta?.alias || [],
    redirect: indexjl4JC2qxKRMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/maker-theme/survey/index.vue").then(m => m.default || m)
  },
  {
    name: indexnxarsyo3GHMeta?.name ?? "my-store",
    path: indexnxarsyo3GHMeta?.path ?? "/my-store",
    meta: indexnxarsyo3GHMeta || {},
    alias: indexnxarsyo3GHMeta?.alias || [],
    redirect: indexnxarsyo3GHMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/my-store/index.vue").then(m => m.default || m)
  },
  {
    name: _91type_93wCpmHlD0hJMeta?.name ?? "my-store-search-type",
    path: _91type_93wCpmHlD0hJMeta?.path ?? "/my-store/search/:type()",
    meta: _91type_93wCpmHlD0hJMeta || {},
    alias: _91type_93wCpmHlD0hJMeta?.alias || [],
    redirect: _91type_93wCpmHlD0hJMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/my-store/search/[type].vue").then(m => m.default || m)
  },
  {
    name: indexiqze3trjr1Meta?.name ?? "my-store-search",
    path: indexiqze3trjr1Meta?.path ?? "/my-store/search",
    meta: indexiqze3trjr1Meta || {},
    alias: indexiqze3trjr1Meta?.alias || [],
    redirect: indexiqze3trjr1Meta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/my-store/search/index.vue").then(m => m.default || m)
  },
  {
    name: index9gsVWZ1suHMeta?.name ?? "preview-chirashi",
    path: index9gsVWZ1suHMeta?.path ?? "/preview/chirashi",
    meta: index9gsVWZ1suHMeta || {},
    alias: index9gsVWZ1suHMeta?.alias || [],
    redirect: index9gsVWZ1suHMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/preview/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewerWcrDU63FXnMeta?.name ?? "preview-chirashi-viewer",
    path: viewerWcrDU63FXnMeta?.path ?? "/preview/chirashi/viewer",
    meta: viewerWcrDU63FXnMeta || {},
    alias: viewerWcrDU63FXnMeta?.alias || [],
    redirect: viewerWcrDU63FXnMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/preview/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: indexglwi6ri8MRMeta?.name ?? "privacy-policy",
    path: indexglwi6ri8MRMeta?.path ?? "/privacy-policy",
    meta: indexglwi6ri8MRMeta || {},
    alias: indexglwi6ri8MRMeta?.alias || [],
    redirect: indexglwi6ri8MRMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexhKRSCStKuFMeta?.name ?? "product",
    path: indexhKRSCStKuFMeta?.path ?? "/product",
    meta: indexhKRSCStKuFMeta || {},
    alias: indexhKRSCStKuFMeta?.alias || [],
    redirect: indexhKRSCStKuFMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexF2uTCHU2aDMeta?.name ?? "theme",
    path: indexF2uTCHU2aDMeta?.path ?? "/theme",
    meta: indexF2uTCHU2aDMeta || {},
    alias: indexF2uTCHU2aDMeta?.alias || [],
    redirect: indexF2uTCHU2aDMeta?.redirect || undefined,
    component: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/pages/theme/index.vue").then(m => m.default || m)
  }
]